import ITHeaderText, { ITHeaderTextWrap } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/Components/ITHeaderText'
import InputTableLeftColumnForm from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/InputTableLeftColumnForm'
import { InputTableLeftTabsProps } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTableLeftColumn/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import '../quoteHeader.sass'

interface QuoteReadOnlyHeaderAccountsProps extends InputTableLeftTabsProps {}

const QuoteReadOnlyHeaderAccounts: React.FC<QuoteReadOnlyHeaderAccountsProps> = ({ headerData, handleChange}) => {
    const accounts = headerData.OrderAccounts
    const { t } = useTwinTranslation()
    const accountsSections: FormRender<any> = []
    if (accounts?.length) {
        for (let key in accounts) {
            const account = accounts[key]
            if (account.name !== '--other') {
                accountsSections.push({
                    cols: 1,
                    className:  `quoteOrderAccount quoteOrderAccountReadOnly ' + ${parseInt(key) === (accounts.length - 1) ? 'isLast' : ''}`,
                    elements: [
                        {
                            name: 'account_' + key,
                            component: 'Custom',
                            render: ({ value }) => <ITHeaderText label={t('chapter', 'Capítulo')} value={account.name} />
                        },
                        {
                            name: 'account_' + key,
                            component: 'Custom',
                            render: ({ value }) => account.description ? <ITHeaderTextWrap label={t('description', 'Descripción')} value={account.description} /> : <div></div>,
                        },
                    ]
                })
            }
        }
    }
    const sections: FormRender<any> = [
        ...accountsSections,
    ]

    return (
        <InputTableLeftColumnForm form={sections} headerData={headerData} handleChange={handleChange} />
    )
}

export default QuoteReadOnlyHeaderAccounts